import styled from 'styled-components';
import { TagMixin } from '../../mixins/components/TagMixin';
export var StyledTag = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledTag",
  componentId: "c11n-8-107-0__sc-1stu7t-0"
})(["", ""], TagMixin);